/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/content-ai-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/content-ai-api-client";
import type { ContentPublishSocialVersionMutationRequest, ContentPublishSocialVersionMutationResponse, ContentPublishSocialVersionPathParams } from "../models/ContentPublishSocialVersion";

export function getContentPublishSocialVersionUrl(id: ContentPublishSocialVersionPathParams["id"], platform: ContentPublishSocialVersionPathParams["platform"]) {
  const res = { method: 'POST', url: `/contents/${id}/social-version/${platform}/publish` as const }  
  return res
}

/**
 * @summary Publish social version to platform
 * {@link /contents/:id/social-version/:platform/publish}
 */
export async function contentPublishSocialVersion(id: ContentPublishSocialVersionPathParams["id"], platform: ContentPublishSocialVersionPathParams["platform"], data: ContentPublishSocialVersionMutationRequest, config: Partial<RequestConfig<ContentPublishSocialVersionMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ContentPublishSocialVersionMutationResponse, ResponseErrorConfig<Error>, ContentPublishSocialVersionMutationRequest>({ method : "POST", url : getContentPublishSocialVersionUrl(id, platform).url.toString(), data : requestData, ... requestConfig })  
  return res.data
}